const emit = (name, options, element) => {
  const event = new CustomEvent(name, {
    bubbles: true,
    cancelable: false,
    composed: true,
    detail: {},
    ...options
  });
  (element || window).dispatchEvent(event);
  return event;
};
const waitForEvent = (el, eventName, listenOnce = false) => {
  return new Promise((resolve) => {
    const done = (event) => {
      if (event.target === el) {
        el.removeEventListener(eventName, done);
        resolve(event.detail);
      }
    };
    el.addEventListener(eventName, done, { once: listenOnce });
  });
};
export {
  emit,
  waitForEvent
};
//# sourceMappingURL=events.js.map
